import { render, staticRenderFns } from "./ProvisioningTerms.vue?vue&type=template&id=5bb5f684&scoped=true"
import script from "./ProvisioningTerms.vue?vue&type=script&lang=js"
export * from "./ProvisioningTerms.vue?vue&type=script&lang=js"
import style0 from "./ProvisioningTerms.vue?vue&type=style&index=0&id=5bb5f684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb5f684",
  null
  
)

export default component.exports